import React from 'react';
import M3Dialog, { DialogBody } from '../../M3Dialog';

// Table of input rows: first few fields, cell values truncated.
function InputTable({ fields, rows, maxRows = 5 }) {
  if (!fields || !fields.length) return <p className="flow-input-empty">No fields available.</p>;
  if (!rows || !rows.length)
    return <p className="flow-input-empty">No rows yet — run the workflow to see input data.</p>;
  const shown = fields.slice(0, 6);
  return (
    <>
      <div className="flow-input-scroll">
        <table className="flow-input-table">
          <thead>
            <tr>
              {shown.map((f) => (
                <th key={f.key}>{f.label || f.key}</th>
              ))}
              {fields.length > 6 && <th>…</th>}
            </tr>
          </thead>
          <tbody>
            {rows.slice(0, maxRows).map((row, i) => (
              <tr key={i}>
                {shown.map((f) => (
                  <td key={f.key}>{formatCell(row[f.key])}</td>
                ))}
                {fields.length > 6 && <td>…</td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {rows.length > maxRows && (
        <p className="flow-input-note">
          {rows.length} rows total — showing {maxRows}
        </p>
      )}
    </>
  );
}

function formatCell(value) {
  if (value == null) return '—';
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  if (Array.isArray(value)) return value.join(', ');
  return String(value).length > 40 ? String(value).slice(0, 40) + '…' : String(value);
}

// M3 dialog showing the input rows of the selected node. Esc, the × and
// the overlay click are handled by M3Dialog itself.
export default function InputPreviewDialog({ fields, rows, onClose }) {
  return (
    <M3Dialog
      open
      title={`Input (${rows?.length || 0} rows, ${fields?.length || 0} fields)`}
      size="wide"
      onClose={onClose}
    >
      <DialogBody>
        <InputTable fields={fields} rows={rows} />
      </DialogBody>
      <M3Dialog.Actions secondary={{ label: 'Close', onClick: onClose }} />
    </M3Dialog>
  );
}
